/**
 * Strip HTML / script-ish content from chat bodies (defense in depth; server must still validate).
 */
export function sanitizeChatPlainText(input: string, maxLen = 8000): string {
  const trimmed = input.replace(/\u0000/g, '').trim().slice(0, maxLen);
  return trimmed
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

export function decodeChatPlainText(stored: string): string {
  return stored
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'");
}
